// RESTful JSON API
const json_api = {
  parse: text => JSON.parse(text)
};

export default json_api;
